import { render, staticRenderFns } from "./ModelEditCard.vue?vue&type=template&id=22c8b8d6&scoped=true"
import script from "./ModelEditCard.vue?vue&type=script&lang=js"
export * from "./ModelEditCard.vue?vue&type=script&lang=js"
import style0 from "./ModelEditCard.vue?vue&type=style&index=0&id=22c8b8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8b8d6",
  null
  
)

export default component.exports